<template>
    <modal name="submitted-documents-modal"
            @closed="$emit('updateComparisonData')"
            @before-close="beforeClose"
            @before-open="beforeOpen"
            style="z-index: 1002;"
    >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Հաղթելուց հետո ներկայացվող փաստաթղթեր</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('submitted-documents-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div>
      <h3 class="text-center pt-3 font-weight-bold">Հաղթելուց հետո ներկայացվող փաստաթղթեր</h3>
      <h4 class="text-center font-weight-bold mb-5 mt-5 w-50">Պատվիրատուի</h4>
      <form class="d-flex p-4" @submit.prevent="submit">
        <div class="w-50 d-flex flex-column">
          <div class="d-flex justify-content-between mb-2 align-items-center">
            <label for="hvhh">ՀՎՀՀ</label>
            <input type="number" id="hvhh" class="submitted-documents-block-input" v-model="$v.ValuesVariable.hvhh.$model">
          </div>
          <div class="d-flex justify-content-between mb-2 align-items-center">
            <label for="bank">Սպասարկող Ֆինանսական կազմակերպություն (բանկ)`</label>
            <input type="text" id="bank" class="submitted-documents-block-input" v-model.trim="$v.ValuesVariable.bank.$model">
          </div>
          <div class="d-flex justify-content-between mb-2 align-items-center">
            <label for="cashNumbers">Հաշվի համարը (հշ.N)</label>
            <input @keypress="isNumber" type="text" id="cashNumbers" class="submitted-documents-block-input" v-model="$v.ValuesVariable.cashNumbers.$model" >
          </div>
        </div>
        <div class="w-50 d-flex flex-column ml-5">
          <div class="d-flex justify-content-between mb-2 align-items-center">
            <label for="sum">Գնման ընդհանուր գինը /եթե գնման գինը պակաս է պայմանագրի գնից, ապա պայմանագրի ընդհանուր գինը/</label>
            <input type="number" id="sum" class="submitted-documents-block-input" v-model.number="$v.ValuesVariable.sum.$model" >
          </div>
          <div class="d-flex justify-content-between mb-2 align-items-center">
            <label for="date">Ներկայացման ամսաթիվ</label>
            <input type="text" id="date" class="submitted-documents-block-input" v-mask="'##/##/####'" v-model.trim="$v.ValuesVariable.date.$model">
          </div>
          <div class="d-flex justify-content-between mb-2 align-items-center">
            <label for="document1">Ընկերության տնօրենի անձնագրային տվյալներ</label>
            <input type="text" id="document1" class="submitted-documents-block-input" v-model.trim="$v.ValuesVariable.document.$model">
          </div>
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button
          @click="submit"
          type="button"
          class="btn btn-primary mt-1"
          style="width: fit-content"
      >
      Հաստատել
      </button>
    </div>
            <div class="d_flex flex-column" :class="{'d-none' : showDocuments}">
              <p class="text-center py-3 font-weight-bold">Հաղթելուց հետո ներկայացվող փաստաթղթեր</p>
              <div class="d-flex justify-content-center">
                <button
                    @click="$modal.show('new-editor-modal', {
                              action: 'download',
                              fileName: 'application_announcement_writing',
                              tender: {...tender, ValuesVariable},
                              editorTitle: `Գրություն`,
                    })"
                    type="button"
                    class="btn btn-primary"
                  >
                      <i class="fas fa-file-alt mr-1" />
                      ԳՐՈՒԹՅՈՒՆ
                </button>
                <button
                    @click="$modal.show('new-editor-modal', {
                              action: 'download',
                              fileName: 'application_announcement_contract_security',
                              tender: {...tender, ValuesVariable},
                              editorTitle: `Պայմանագրի ապահովում`,
                    })"
                    type="button"
                    class="btn btn-primary ml-3"
                  >
                      <i class="fas fa-file-alt mr-1" />
                      Պայմանագրի ապահովում 
                </button>
                <button
                    @click="$modal.show('new-editor-modal', {
                              action: 'download',
                              fileName: 'application_announcement_qualification_assurance',
                              tender: {...tender, ValuesVariable},
                              editorTitle: `Որակավորման ապահովում`,
                    })"
                    type="button"
                    class="btn btn-primary ml-3"
                  >
                      <i class="fas fa-file-alt mr-1" />
                      Որակավորման ապահովումը
                </button>
              </div>
              <div class="mt-3 d-flex justify-content-center">
                <button
                    @click="sendToContractManagement"
                    type="button"
                    class="btn btn-primary ml-3"
                  >
                    Կազմել ընդունման-հանձնման արձանագրությունները
                </button>
              </div>
            </div>
    </modal>    
</template>
<script>
  import {required} from 'vuelidate/lib/validators'
  export default{
    data(){
      return{
        getSubmittedDocuments : {},
        allParams: {},
        ValuesVariable: {
          hvhh: '',
          bank: '',
          cashNumbers: '',
          sum: '',
          date: '',
          document: '',
        },
        showDocuments: true,
        tender: {},
        realBeneficiaries: [
          {
            name_surname: '',
            armenian_card_number: '',
            international_card_number: '',
          }
        ],
        items: {},
      }
    },
    validations: {
      ValuesVariable: {
        hvhh: { required},
        bank: { required },
        cashNumbers: { required },
        sum: { required},
        date: { required },
        document: { required }
      }
    },
    mounted(){

    },
    methods: {
      submit() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.showDocuments = true
        }else {
          this.showDocuments = false
        }
      },
      isNumber (evt){
        const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '_'];
        const keyPressed = evt.key;
        console.log('aa')
        if (!keysAllowed.includes(keyPressed)) {
          evt.preventDefault()
        }
      },
      sendToContractManagement(){
        const contractRequest = {
          code: this.tender.tender.password,
          type: this.tender.tender.cpv_type,
          from_application: true,
          is_sign: true,
          provider_user_id: this.me.id,
          client: {
            name: this.tender.tender.organizator,
            tin: this.ValuesVariable.hvhh,
            bank: this.ValuesVariable.bank,
            account_number: this.ValuesVariable.cashNumbers,
          },
        };
        this.$client.post(`contract/fromApplication`, contractRequest).then((response) => {
          if(response){
            this.$router.push('/contract-management/contracts')
          }
        }).catch(e => {
          console.log(e)
        })
      },
      beforeClose(){
        console.log(this.ValuesVariable.cashNumbers)
        console.log(this.ValuesVariable)
        this.getSubmittedDocumentData(this.ValuesVariable)
      },
      async beforeOpen({params}){
        this.getSubmittedDocumentData = params.tender.getSubmittedDocumentData
        console.log(this.getSubmittedDocumentData)
        this.tender = params.tender
        if(params.tender.submittedDocumentData){
          this.ValuesVariable = params.tender.submittedDocumentData
        }
        console.log(this.ValuesVariable)
      },
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
    },
  }
</script>

<style scoped>
  .submitted-documents-block-input{
    border-radius: 3px;
    border: 1px solid gray;
    padding: 5px;
    margin-left: 25px;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    position: absolute;
    overflow: inherit !important;
    width: 750px !important;
    height: 750px !important;
    padding-bottom: 0px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .d_flex{
    display: flex;
  }
</style>
